import { checkDefined } from 'faro-common-model';
import { toAnalyticsConfig } from './analytics-config.js';
import { toAppInsightsClientConfig } from './app-insights-client-config.js';
import { toImportExportVersionConfig } from './import-export-version-config.js';
import { toIntraDayConfig } from './intraday-config.js';
export function toSystemConfig(config) {
    checkDefined(config.appInsightsClientConfig, 'SystemConfig', 'appInsightsClientConfig');
    return {
        appInsightsClientConfig: toAppInsightsClientConfig(config.appInsightsClientConfig),
        intercom: config.intercom,
        analyticsConfig: toAnalyticsConfig(config.analyticsConfig),
        importExportVersionConfig: toImportExportVersionConfig(config.importexport),
        intraDay: toIntraDayConfig(config.intraDay),
        tinymceConfig: config.tinymceConfig,
    };
}
//# sourceMappingURL=system-config.js.map